var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalShown,
          expression: "modalShown"
        }
      ],
      staticClass: "modal",
      attrs: { id: "mail-modal" }
    },
    [
      _c("div", { staticClass: "modal-main", attrs: { id: "mail-main" } }, [
        _c(
          "div",
          {
            staticClass: "cross_btn",
            on: {
              click: function($event) {
                _vm.close()
              }
            }
          },
          [_c("span", { staticClass: "css-cancel" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mail_area" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.mailAddress,
                expression: "mailAddress",
                modifiers: { trim: true }
              }
            ],
            attrs: {
              type: "text",
              placeholder: "メールアドレスを入力してください。"
            },
            domProps: { value: _vm.mailAddress },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.mailAddress = $event.target.value.trim()
              },
              blur: function($event) {
                _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  _vm.inviteUser()
                }
              }
            },
            [_vm._v("招待する")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "error_message" }, [
          _vm._v(_vm._s(_vm.errors.email))
        ])
      ]),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4505498c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4505498c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/user/InviteUserModal.vue
// module id = null
// module chunks = 